import { GetOrganizationTemplatesResponse } from "@core/types/ApiResponses";

export const isGetOrganizationTemplatesResponse = (obj: any): obj is GetOrganizationTemplatesResponse => {
  return obj && Array.isArray(obj.items);
}
